import { Image, Info } from 'components';

export default function RangeOfExpectedResultsInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person holding a magnifying glass and a ruler" path="range-of-expected-results.png" title="Range of Expected Results" />
        <h5>Range of Expected Results</h5>
        <p>
            This is the maximum and minimum results you think the experiment will produce. It can help reduce the sample size you need to achieve your <span className="fst-italic">Target Margin of Error</span>.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> If you want to survey how many people in the US love Vin Diesel with a <span className="fst-italic">Target Margin of Error</span> of 5%, you need a sample size of 384. But if you think there is no way more than 20% or less than 5% of people love Vin Diesel, then you only need a sample size of 246 to get a 5% <span className="fst-italic">Margin of Error</span>.
            <br/>
            <br/>
            If your actual results exceed your <span className="fst-italic">Range of Expected Results</span> you may have to collect more samples. So choose a maximum and minimum range where you do not expect to exceed or leave this blank.
        </p>
    </Info>;

}